<div class="template-editor-container">
  <div class="editor-layout">
    <div class="main-content">
      <div class="top-menu" #topMenu>
        <div class="menu-actions">
          @if (isActive('INDENT')) {
            <button mat-stroked-button (click)="indentItem()" [disabled]="!canIndent()">
              <mat-icon>chevron_right</mat-icon>
              {{ 'TEMPLATES.EDITOR.INDENT' | translate }}
            </button>
          }
          @if (isActive('OUTDENT')) {
            <button mat-stroked-button (click)="outdentItem()" [disabled]="!canOutdent()">
              <mat-icon>chevron_left</mat-icon>
              {{ 'TEMPLATES.EDITOR.OUTDENT' | translate }}
            </button>
          }
          @if (isActive('ADD_ITEM')) {
            <button mat-stroked-button (click)="addNewItem()">
              <mat-icon>add</mat-icon>
              {{ 'TEMPLATES.EDITOR.ADD_ITEM' | translate }}
            </button>
          }
          @if (isActive('ADD_SUB_ITEM')) {
            <button mat-stroked-button (click)="addSubItem()" [disabled]="!selectedItemId">
              <mat-icon>add</mat-icon>
              {{ 'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate }}
            </button>
          }
          @if (isActive('REMOVE')) {
            <button mat-stroked-button class="remove-button" (click)="removeItem()" [disabled]="!selectedItemId">
              <mat-icon>delete</mat-icon>
              {{ 'TEMPLATES.EDITOR.REMOVE' | translate }}
            </button>
          }
          @if (isActive('DUPLICATE')) {
            <button mat-stroked-button (click)="duplicateItem()" [disabled]="!selectedItemId">
              <mat-icon>content_copy</mat-icon>
              {{ 'TEMPLATES.EDITOR.DUPLICATE' | translate }}
            </button>
          }
          @if (isActive('EXPAND_ALL')) {
            <button mat-stroked-button (click)="expandAll()">
              <mat-icon>unfold_more</mat-icon>
              {{ 'TEMPLATES.EDITOR.EXPAND_ALL' | translate }}
            </button>
          }
          @if (isActive('COLLAPSE_ALL')) {
            <button mat-stroked-button (click)="collapseAll()">
              <mat-icon>unfold_less</mat-icon>
              {{ 'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate }}
            </button>
          }
          @if (displayMenuButton) {
            <button mat-icon-button [matMenuTriggerFor]="overflowMenu" class="overflow-menu-button">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #overflowMenu="matMenu">
            @if (!isActive('INDENT')) {
              <button mat-menu-item (click)="indentItem()" [disabled]="!canIndent()">
                <mat-icon>chevron_right</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.INDENT' | translate }}</span>
              </button>
            }
            @if (!isActive('OUTDENT')) {
              <button mat-menu-item (click)="outdentItem()" [disabled]="!canOutdent()">
                <mat-icon>chevron_left</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.OUTDENT' | translate }}</span>
              </button>
            }
            @if (!isActive('ADD_ITEM')) {
              <button mat-menu-item (click)="addNewItem()">
                <mat-icon>add</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.ADD_ITEM' | translate }}</span>
              </button>
            }
            @if (!isActive('ADD_SUB_ITEM')) {
              <button mat-menu-item (click)="addSubItem()" [disabled]="!selectedItemId">
                <mat-icon>add</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate }}</span>
              </button>
            }
            @if (!isActive('REMOVE')) {
              <button mat-menu-item (click)="removeItem()" [disabled]="!selectedItemId">
                <mat-icon>delete</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.REMOVE' | translate }}</span>
              </button>
            }
            @if (!isActive('DUPLICATE')) {
              <button mat-menu-item (click)="duplicateItem()" [disabled]="!selectedItemId">
                <mat-icon>content_copy</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.DUPLICATE' | translate }}</span>
              </button>
            }
            @if (!isActive('EXPAND_ALL')) {
              <button mat-menu-item (click)="expandAll()">
                <mat-icon>unfold_more</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.EXPAND_ALL' | translate }}</span>
              </button>
            }
            @if (!isActive('COLLAPSE_ALL')) {
              <button mat-menu-item (click)="collapseAll()">
                <mat-icon>unfold_less</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate }}</span>
              </button>
            }
            @if (!isActive('REVERT')) {
              <button mat-menu-item (click)="revertToLastSaved()" [disabled]="!hasUnsavedChanges">
                <mat-icon>undo</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.REVERT' | translate }}</span>
              </button>
            }
          </mat-menu>
        </div>
        <div class="save-actions">
          @if (isActive('REVERT')) {
            <button mat-stroked-button (click)="revertToLastSaved()" [disabled]="!hasUnsavedChanges">
              <mat-icon>undo</mat-icon>
              {{ 'TEMPLATES.EDITOR.REVERT' | translate }}
            </button>
          }
          <button mat-flat-button color="primary" (click)="saveTemplate()" [disabled]="!hasUnsavedChanges">{{ 'TEMPLATES.EDITOR.SAVE' | translate }}</button>
        </div>
      </div>

      <div class="content-wrapper" (click)="deselectItem($event)">
        <div class="items-container" cdkDropList (cdkDropListDropped)="onItemDrop($event)">
          @for (item of flattenedItems; track item.id) {
            <app-template-item
              [item]="item"
              [availableResources]="availableResources"
              [allowFileUpload]="allowFileUpload"
              [selectedItemId]="selectedItemId"
              (itemSelected)="selectItem($event)"
              (contentChanged)="markAsChanged()"
              (fileUploadRequested)="fileUploadRequested.emit($event)"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
